import { Component, type ReactNode } from "react";
import { Map } from "lucide-react";
import { Link } from "react-router-dom";

import { APP_PATHS } from "./routes";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  public state: AppErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public render() {
    if (this.state.hasError) {
      return (
        <section
          aria-labelledby="app-shell-error-title"
          className="app-shell__error"
          role="alert"
        >
          <p className="app-shell__eyebrow">航线提醒</p>
          <h1 id="app-shell-error-title">航线暂时停住了</h1>
          <p>别担心，回到岛屿地图再试一次。</p>
          <Link className="app-shell__primary-action" to={APP_PATHS.map}>
            <Map aria-hidden="true" size={24} strokeWidth={2.5} />
            回到岛屿地图
          </Link>
        </section>
      );
    }

    return this.props.children;
  }
}
